import { render, staticRenderFns } from "./buyCarPart.vue?vue&type=template&id=6a2a6ea8&scoped=true&"
import script from "./buyCarPart.vue?vue&type=script&lang=js&"
export * from "./buyCarPart.vue?vue&type=script&lang=js&"
import style0 from "./buyCarPart.vue?vue&type=style&index=0&id=6a2a6ea8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2a6ea8",
  null
  
)

export default component.exports